import {defineQuery} from 'next-sanity';

import type {SiteSettingsSchema} from './schema';

export const SITE_SETTINGS_QUERY = defineQuery(`
	*[_type == "siteSettings"][0]{
		...,
		meta{
			...,
			image{
				asset->{
					url,
					metadata{
						dimensions{
							width,
							height
						}
					}
				}
			}
		}
	}
`);

export type SiteSettingsQueryResult = SiteSettingsSchema | null;
